import { FunnelSimple } from "@phosphor-icons/react";

import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuList,
  DropdownMenuPortal,
  DropdownMenuSub,
  DropdownMenuSubContent,
  DropdownMenuSubTrigger,
  DropdownMenuTrigger,
} from "common/components/ui/DropdownMenu";
import FilterButton from "common/components/ui/FilterButton";
import { typedObjectEntries } from "common/helpers/utils";

import { ACCOUNTS_FILTERS } from "../../constants";
import AccountFilterOptions from "../AccountFilterOptions";

import type { AccountSearchParams } from "../../types";

export default function DesktopFilters({
  searchParams,
  setSearchParams,
}: {
  searchParams: AccountSearchParams;
  setSearchParams: (searchParams: AccountSearchParams) => void;
}) {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <FilterButton leftIcon={<FunnelSimple />}>Filter</FilterButton>
      </DropdownMenuTrigger>
      <DropdownMenuContent>
        <DropdownMenuList>
          {typedObjectEntries(ACCOUNTS_FILTERS).map(
            <SearchParamsKey extends keyof AccountSearchParams>([
              key,
              { icon, label },
            ]: [
              SearchParamsKey,
              (typeof ACCOUNTS_FILTERS)[SearchParamsKey],
            ]) => {
              return (
                <DropdownMenuSub key={key}>
                  <DropdownMenuSubTrigger>
                    {icon}
                    {label}
                  </DropdownMenuSubTrigger>
                  <DropdownMenuPortal>
                    <DropdownMenuSubContent>
                      <DropdownMenuList>
                        <AccountFilterOptions
                          searchParamsKey={key}
                          setSearchParams={setSearchParams}
                          searchParams={searchParams}
                        />
                      </DropdownMenuList>
                    </DropdownMenuSubContent>
                  </DropdownMenuPortal>
                </DropdownMenuSub>
              );
            },
          )}
        </DropdownMenuList>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
